import { render, staticRenderFns } from "./ElementalDisciplines.vue?vue&type=template&id=3a457b3a&scoped=true"
import script from "./ElementalDisciplines.vue?vue&type=script&lang=js"
export * from "./ElementalDisciplines.vue?vue&type=script&lang=js"
import style0 from "./ElementalDisciplines.vue?vue&type=style&index=0&id=3a457b3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a457b3a",
  null
  
)

export default component.exports